import { sendRequest, sendRequestProtocols } from "../axios";

export default {
  state: {},
  mutations: {},
  actions: {
    async SEND_INN_TO_CHECK({ commit }, obj) {
      const {val,err} = obj
      return await sendRequestProtocols(
        `gosebase/companiesInfoByInn/${val}`,
        "get",
        undefined,
        err
      );
    },
    async checkInnList(state, list) {
      return (
        await sendRequestProtocols(`dadata/checkInnList`, "post", list)
      ).data;
    },

    async setWinnersList(state, obj) {
      const fd = new FormData();
      fd.append("data", JSON.stringify(obj));
      const { data } = await sendRequest(
        "setWinnersList",
        "post",
        fd
      );
      return data;
    },
    async getMyWinners({ commit }, obj) {
      const fd = new FormData();
      fd.append("user_id", obj.user_id);
      fd.append("page", obj.pagination.page);
      fd.append("itemsPerPage", obj.pagination.itemsPerPage);
      fd.append("sortBy", obj.pagination.sortBy[0]);
      fd.append("sortDesc", obj.pagination.sortDesc[0]);
      const { data } = await sendRequest(
        "getAllUserWinners",
        "post",
        fd
      );
      return data;
    },
    async getUsersWinners({ commit }, obj) {
      const fd = new FormData();
      fd.append("user_id", obj.user_id);
      fd.append("selectedUser", obj.selectedUser);
      fd.append("search", obj.search);
      fd.append("page", obj.pagination.page);
      fd.append("itemsPerPage", obj.pagination.itemsPerPage);
      fd.append("sortBy", obj.pagination.sortBy[0]);
      fd.append("sortDesc", obj.pagination.sortDesc[0]);
      const { data } = await sendRequest(
        "getUsersWinners",
        "post",
        fd
      );
      return data;
    },
    async removeWinner({ commit }, obj) {
      const fd = new FormData();
      fd.append("user_id", obj.user_id);
      fd.append("id", obj.id);
      const { data } = await sendRequest(
        "removeUserWinners",
        "post",
        fd
      );
      return data;
    },
    async SaveMailWinners({ commit }, payload) {
      return await sendRequestProtocols(`mailing/44`, "post", payload);
    },
    async LoadMailWinners({ commit },) {
      return await sendRequestProtocols(`mailing/44`, "get");
    },
    async SaveMailWinners615({ commit }, payload) {
      return await sendRequestProtocols(`mailing/615`, "post", payload);
    },
    async LoadMailWinners615({ commit },) {
      return await sendRequestProtocols(`mailing/615`, "get");
    },
    async SaveWinnersFZ223({ commit }, payload) {
      return await sendRequestProtocols(`mailing/223`, "post", payload);
    },
    async LoadWinnersFZ223({ commit },) {
      return await sendRequestProtocols(`mailing/223`, "get");
    },
  },
  getters: {
    // getRegionRe: (state) =>state.regions_re,
  }
};
